/* tslint:disable */
/* eslint-disable */
/**
 * users
 * users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CurrentUserDetailOrganizationDetails
 */
export interface CurrentUserDetailOrganizationDetails {
    /**
     * 
     */
    id: number;
    /**
     * 
     */
    name: string;
}

/**
 * Check if a given object implements the CurrentUserDetailOrganizationDetails interface.
 */
export function instanceOfCurrentUserDetailOrganizationDetails(value: object): value is CurrentUserDetailOrganizationDetails {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function CurrentUserDetailOrganizationDetailsFromJSON(json: any): CurrentUserDetailOrganizationDetails {
    return CurrentUserDetailOrganizationDetailsFromJSONTyped(json, false);
}

export function CurrentUserDetailOrganizationDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): CurrentUserDetailOrganizationDetails {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
    };
}

export function CurrentUserDetailOrganizationDetailsToJSON(json: any): CurrentUserDetailOrganizationDetails {
    return CurrentUserDetailOrganizationDetailsToJSONTyped(json, false);
}

export function CurrentUserDetailOrganizationDetailsToJSONTyped(value?: CurrentUserDetailOrganizationDetails | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}

